import React from 'react';
import { Segment } from '@/types/symbols/exchangeTypes';

interface SegmentTabsProps {
    segment: Segment;
    onSegmentChange: (segment: Segment) => void;
}

const SegmentTabs: React.FC<SegmentTabsProps> = ({ segment, onSegmentChange }) => (
    <div className='mb-3 flex sm:inline-flex items-center bg-gray-200/60 dark:bg-white/10 p-1 rounded-xl gap-1 w-full sm:w-auto shrink-0'>
        <button
            type='button'
            className={`flex-1 sm:flex-initial whitespace-nowrap px-4 py-2 text-xs font-semibold rounded-lg transition-all duration-200 cursor-pointer text-center ${
                segment === 'buy'
                    ? 'bg-emerald-500/15 dark:bg-emerald-500/25 text-emerald-700 dark:text-emerald-300 border border-emerald-500/30 shadow-xs'
                    : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
            }`}
            onClick={() => onSegmentChange('buy')}
        >
            کجا بخریم
        </button>
        <button
            type='button'
            className={`flex-1 sm:flex-initial whitespace-nowrap px-4 py-2 text-xs font-semibold rounded-lg transition-all duration-200 cursor-pointer text-center ${
                segment === 'sell'
                    ? 'bg-rose-500/15 dark:bg-rose-500/25 text-rose-700 dark:text-rose-300 border border-rose-500/30 shadow-xs'
                    : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
            }`}
            onClick={() => onSegmentChange('sell')}
        >
            کجا بفروشیم
        </button>
    </div>
);

export default SegmentTabs;
